import { configureStore } from "@reduxjs/toolkit";
import seriesSlice2d from "./2d-slice/seriesSlice2d";
import seriesSlice1d from "./1d-slice/seriesSlice1d";
import gameInfo2dSlice from "./2d-slice/gameInfo2dSlice";
import gameInfoTitliSlice from "./titli-slice/gameInfoTitliSlice";
import gameInfo1dSlice from "./1d-slice/gameInfo1dSlice";
import errorMessageSlice from "./errorMessageSlice";
import loaderlice from "./loaderSlice";
import successMessageSlice from "./successMessageSlice";
import panelSlice from "./3d_game_Slice/panelSlice"; // Import your panelSlice
import gameInfo3dSlice from "./3d_game_Slice/gameinfo3d"; // Import your panelSlice
import seriesSlice from "../redux/seriesSlice"; // Import your panelSlice

export default configureStore({
    reducer: {
        seriesSlice2d,
        seriesSlice1d,
        seriesSlice,
        loaderlice,
        errorMessageSlice,
        gameInfo2dSlice,
        gameInfo1dSlice,
        gameInfoTitliSlice,
        gameInfo3dSlice,
        successMessageSlice,
        panelSlice, // Add this line to include your panel reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })
})